const styles = {
  defaultLinkStyles:
    "block px-4 py-2 lg:p-0 text-white text-base font-semibold hover:bg-defaultGray lg:hover:text-defaultYellow lg:hover:bg-transparent duration-150",
  activeLinkStyles: "text-defaultYellow",
  search: "w-4 h-4 text-black",
};

export default styles;
